import React from 'react';

const defaultValues = {
  selectedItemsDocIds: [],
  selectedItemsIds: [],
  pageView: null,
  setSelectedItemsDocIds: (e) => {},
  setSelectedItemsIds: (e) => {},
  setPageView: (e) => {},
};

const DocsCtx = React.createContext(defaultValues);

export default DocsCtx;
